import CryptoJS from 'crypto-js';
import fetchJsonp from 'fetch-jsonp';

export const tanslateChFromToEnAddress = async (
  province: string = '',
  city: string = '',
  receipient: string = '',
  addressDetail: string = '',
) => {
  return await new Promise((resolve, reject) => {
    const text = `${province}\n${city}\n${receipient}\n${addressDetail}`;

    // @ts-ignore
    const appKey = import.meta.env.VITE_YOUDAO_APP_KEY;
    // @ts-ignore
    const key = import.meta.env.VITE_YOUDAO_KEY;
    const salt = new Date().getTime();
    const curtime = Math.round(new Date().getTime() / 1000);
    const query = text;
    const from = 'zh-CHS';
    const to = 'en';
    const str1 = appKey + truncate(query) + salt + curtime + key;
    const sign = CryptoJS.SHA256(str1).toString(CryptoJS.enc.Hex);

    const payload = {
      q: query,
      appKey: appKey,
      salt: salt.toString(),
      from: from,
      to: to,
      sign: sign,
      signType: 'v3',
      curtime: curtime.toString(),
    };

    fetchJsonp(
      `https://openapi.youdao.com/api?${new URLSearchParams(payload)}`,
      {
        jsonpCallback: 'callback', // 서버에서 요구하는 콜백 이름 (API 문서 참고)
        timeout: 5000, // 타임아웃 설정
      },
    ).then(async (res: any) => {
      const json = await res.json();
      const translateArray = json.translation[0].split('\n');
      const stateProvinceRegionEng = translateArray[0];
      const cityEng = translateArray[1];
      const addressEng = translateArray[2];
      const addressDetailEng = translateArray[3];
      resolve({
        stateProvinceRegionEng,
        cityEng,
        addressEng,
        addressDetailEng,
      });
    });
  });
};

function truncate(q: any) {
  const len = q.length;
  if (len <= 20) {
    return q;
  }
  return q.substring(0, 10) + len + q.substring(len - 10);
}
